import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/storage';

const config = {
  apiKey: "AIzaSyB8VFvqKLFxbv9ahIQbGQEd64WdiPTpJxk",
  authDomain: "snft-6efcb.firebaseapp.com",
  projectId: "snft-6efcb",
  storageBucket: "snft-6efcb.appspot.com",
  messagingSenderId: "388627218000",
  appId: "1:388627218000:web:f22e1df79d9b3ca2b19b55",
  measurementId: "G-ZSCP1Q2BVL"
};


class Firebase {
  constructor() {
    app.initializeApp(config);
    this.auth = app.auth();
    this.db = app.database();
    this.firestore = app.firestore();
    this.RecaptchaVerifier = app.auth.RecaptchaVerifier;
    this.storage = app.storage();
  }

  setSession = () =>
    this.auth.setPersistence(app.auth.Auth.Persistence.SESSION);

  doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  getCurrentLoginUser = () => {
    var user = app.auth().currentUser;
    return user;

  }

  signInWithYahoo = () => {
    var provider = new app.auth.OAuthProvider('yahoo.com');
    app.auth().signInWithPopup(provider)
      .then((result) => {
        // IdP data available in result.additionalUserInfo.profile
        // ...

        /** @type {firebase.auth.OAuthCredential} */
        const credential = result.credential;

        // Yahoo OAuth access token and ID token can be retrieved by calling:
        var accessToken = credential.accessToken;
        var idToken = credential.idToken;
      })
      .catch((error) => {
        // Handle error.
      });
  }

  signInWithGoogle = () => {
    var provider = new app.auth.GoogleAuthProvider();
    provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
    app.auth()
      .signInWithPopup(provider)
      .then((result) => {
        /** @type {firebase.auth.OAuthCredential} */
        var credential = result.credential;

        // This gives you a Google Access Token. You can use it to access the Google API.
        var token = credential.accessToken;
        // The signed-in user info.
        var user = result.user;
        // ...
      }).catch((error) => {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // ...
      });
  }

  signInWithFacebook = () => {
    const provider = new app.auth.FacebookAuthProvider();
    provider.setCustomParameters({
      'display': 'popup'
    });
    app
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        /** @type {firebase.auth.OAuthCredential} */
        var credential = result.credential;

        // The signed-in user info.
        var user = result.user;

        // This gives you a Facebook Access Token. You can use it to access the Facebook API.
        var accessToken = credential.accessToken;

        // ...
      })
      .catch((error) => {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;

        // ...
      });
  }




  doSignOut = () => this.auth.signOut();

  doPasswordReset = (email) => this.auth.sendPasswordResetEmail(email);
  doConfirmPasswordReset = (code, newPassword) =>
    this.auth.confirmPasswordReset(code, newPassword);

  doUpdateVerifyEmail = (code) => this.auth.applyActionCode(code);

  doPasswordUpdate = (currentPassword, newPassword) => {
    const user = this.auth.currentUser;
    const credential = app.auth.EmailAuthProvider.credential(
      this.auth.currentUser.email,
      currentPassword,
    );
    return user
      .reauthenticateAndRetrieveDataWithCredential(credential)
      .then((res) => {
        this.auth.currentUser.updatePassword(newPassword);
      });
  };

  // *** User API ***
  // user = uid => this.db.ref(`users/${uid}`);
  // users = () => this.db.ref("users");

  user = (uid) =>
    this.firestore
      .collection('users')
      .doc(uid)
      .get()
      .then((userData) => {
        if (userData.data()) {
          return this.getProfilePicture(userData.data().uid)
            .then((userProfileUrl) => {
              const userJSON = { ...userData.data(), image: userProfileUrl };
              return userJSON;
            })
            .catch((error) => {
              const userJSON = { ...userData.data() };
              return userJSON;
            });
        } else {
          const userJSON = userData.data();
          return userJSON;
        }
      });

}

export default Firebase;